import api from './api';

class SmsSetupService {

  checkCheckoutSessionStripe(dataForm, merchant_code) {
    return api.post('/payment/check-checkout-session-stripe', dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    }
    );
  }

  // SMS
  getSmsBal() {
    return api.get('/merchant/get-sms-bal');
  }
  checkoutSessionStripeForSms(dataForm) {
    return api.post('/merchant/checkout-session-stripe-for-sms', dataForm);
  }
  checkoutHppAirwallexForSms(dataForm) {
    return api.post('/merchant/checkout-hpp-airwallex-for-sms', dataForm);
  }
  addSmsBal(dataForm) {
    return api.post('/merchant/add-sms-bal', dataForm);
  }
  getSmsPaymentHistory() {
    return api.get('/merchant/get-sms-payment-history');
  }
  closeWarningSms() {
    return api.post('/merchant/close-warning-sms');
  }

  // WhatsApp
  getWaBal() {
    return api.get('/merchant/get-wa-bal');
  }
  checkoutSessionStripeForWa(dataForm) {
    return api.post('/merchant/checkout-session-stripe-for-wa', dataForm);
  }
  checkoutHppAirwallexForWa(dataForm) {
    return api.post('/merchant/checkout-hpp-airwallex-for-wa', dataForm);
  }
  // Used by both the Stripe and Airwallex SMS-return flows. Pass either
  // `session_id` (Stripe) or `airwallex_intent_id` (Airwallex) plus `price`
  // and `sms_bal`.
  checkHppAirwallex(dataForm, merchant_code) {
    return api.post('/payment/check-hpp-airwallex', dataForm, {
      headers: {
        'MerchantCode': merchant_code,
      },
    });
  }
  getDefaultPaymentMode() {
    return api.get('/merchant/get-default-payment-mode');
  }

  addWaBal(dataForm) {
    return api.post('/merchant/add-wa-bal', dataForm);
  }
  getWaPaymentHistory() {
    return api.get('/merchant/get-wa-payment-history');
  }
  closeWarningWa() {
    return api.post('/merchant/close-warning-wa');
  }
}

export default new SmsSetupService();
